import "./App.css";
import Header from "./components/header/header";
import Image from "./components/image/image";
import Video from "./components/video/video";
import Stats from "./components/stats/stats";
import Benefits from "./components/benefits/benefits";
import Opinions from "./components/opinions/opinions";
import ModuleList from "./components/moduleList/moduleList";
import LessonCards from "./components/lessonCards/lessonCards";
import TrainerCard from "./components/TrainerCard/TrainerCard";
import Offert from "./components/Offert/Offert";
import Focuss from "./components/Focuss/Focuss";
import Need from "./components/Need/Need";
import MindMap from "./components/mindMap/mindMap";
import ProductImage from "./components/ProductImage/ProductImage";
import Buy from "./components/Buy/Buy";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Image />
      <Video videoId="qfXmQLT5gys" />{" "}
      {/* To z jakiegos powodu musi byc w props bo yt odrzuca  */}
      <Stats />
      <Benefits />
      {/* <Opinions /> */}
      <ModuleList />
      <LessonCards />
      <TrainerCard />
      {/* <Offert /> */}
      <Need />
      <Focuss />
      <MindMap />
      <ProductImage />
      <Buy />
      <Footer />
    </div>
  );
}

export default App;
